import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link, browserHistory } from 'react-router';
import { ShowIf } from 'components/utils';
import { Text, TextMessage } from 'components/tt-forms/common';
import {BlockGiaiQuyetDonInfo} from 'modules/giai-quyet-don/subView';

class KetQuaLapDuThaoDonKhieuNaiCanBo extends React.Component {
  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  componentDidMount() {
    if (window.debug) {
      console.log('giai-quyet-don/subView/KetQuaLapDuThaoDonKhieuNaiCanBo');
    }
  }

  render() {
    let ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(state => {
      return state.giaTri == this.props.ketLuanNoiDungKhieuNai
    });

    let ketQuaThucHien = this.props.dataKetQuaThucHien.filter(state => {
      return state.giaTri == this.props.ketQuaThucHienTheoDoi
    });

    let {thongTinGQD} = this.props;

    return (
      <section className="wrap-block">
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={thongTinGQD}/>
        <div className="row pl15 pr15">
          <div className="col-100 mt5 no-gutter">
            <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
            <div className="row pl10 pr10">
              <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
              <Text className="col-25 mb10" label='' value={this.props.ketQuaXLDGiaiQuyetInfo ? this.props.ketQuaXLDGiaiQuyetInfo.text : ''}/>
            </div>
          </div>

          <ShowIf condition={this.props.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI'}>
            <div className="row pl10 pr10">
              <Text value={this.props.ngayHetHanGiaiQuyet ? moment(this.props.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : ''} label='Hạn giải quyết:' className='col-25 mb10'/>
              <Text value={this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''} red={true} label='Thời gian báo cáo kết quả:' className='col-25 mb10'/>
              <Text value={this.props.yKienCuaDonViGiaoTTXM || ''} label='Ý kiến xử lý:' className='col-100 mb10'/>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
            <ShowIf condition={this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
              <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
              {
                (thongTinGQD && thongTinGQD.ketQuaGiaiQuyetLan2Info) &&
                <div className="row pl10 pr10 mb15">
                  <Text className="col-25 mb0-18" label="Kết quả giải quyết:" value={thongTinGQD.ketQuaGiaiQuyetLan2Info.text}/>
                </div>
              }
              <div className="row pl10 pr10 mb15">
                <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.soVuGiaiQuyetKhieuNai)}/>
                <Text label="Kết luận nội dung khiếu nại:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
                <Text className="col-25 mb0-18" label="Kết quả khác:" value={this.props.ketQuaGiaiQuyetKhac ? this.props.ketQuaGiaiQuyetKhac : ''}/>
              </div>

              <div className="row pl10 pr10 mb5">
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={String(this.props.tienPhaiThuNhaNuocQDGQ)}/>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={String(this.props.datPhaiThuNhaNuocQDGQ)}/>
                </div>
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={String(this.props.tienPhaiTraCongDanQDGQ)}/>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={String(this.props.datPhaiTraCongDanQDGQ)}/>
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                  <Text className="col-25 mb0-18" type="sdt" label="Tổng số người:" value={String(this.props.tongSoNguoiXuLyHanhChinh)}/>
                  <Text className="col-25 mb0-18" type="sdt" label="Số người đã bị xử lý:" value={String(this.props.soNguoiDaBiXuLyHanhChinh)}/>
                  <Text className="col-25 mb0-18" label="Số người được trả lại quyền lợi:" value={String(this.props.soNguoiDuocTraLaiQuyenLoi)}/>
                </div>
              </div>
            </ShowIf>
            <ShowIf condition={this.props.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định đình chỉ</h3>
              <Text className="col-25 pl0 mb10" label="Số văn bản:" value={this.props.soVanBan || ''}/>
              <Text className="col-25 mb10" label="Ngày ban hành:" value={this.props.ngayBanHanh ? moment(this.props.ngayBanHanh).format('DD/MM/YYYY') : ''}/>
              <Text className="col-25 mb10" label="Người ký:" value={this.props.nguoiBanHanhInfo ? this.props.nguoiBanHanhInfo.hoVaTen : ''}/>
              <TextMessage className='col-100 pl0 mb15' label='Lý do đình chỉ:' value={this.props.lyDoBanHanhQuyetDinhDinhChi || ''}/>
            </ShowIf>

            <ShowIf condition={this.props.theoDoiThucHien && this.props.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
              <div className="col-100 no-gutter">
                <div className="pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                  <div className="row pl10 pr10 mb15">
                    <Text className="col-25 mb0-18" label="Kết quả thực hiện:" value={ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : ''}/>
                    <Text className="col-25 mb0-18" label="Kết quả thực hiện khác:" value={this.props.ketQuaThucHienKhac ? this.props.ketQuaThucHienKhac : ''}/>
                  </div>
                  <div className="row pl10 pr10">
                    <div className="col-100 no-gutter mb20">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={String(this.props.tienPhaiThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={String(this.props.datPhaiThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ):" value={String(this.props.tienDaThuNhaNuoc)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2):" value={String(this.props.datDaThuNhaNuoc)}/>
                    </div>
                    <div className="col-100 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={String(this.props.tienPhaiTraCongDan)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={String(this.props.datPhaiTraCongDan)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ):" value={String(this.props.tienDaTraCongDan)}/>
                      <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2):" value={String(this.props.datDaTraCongDan)}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.giaoCoQuanDieuTra}>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100 no-gutter mt5 pb5">
                  <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                  <div className="row pl10 pr10">
                    <Text className="col-25 mb0-18" label="Tên cơ quan:" value={this.props.coQuanDieuTraInfo ? this.props.coQuanDieuTraInfo.ten : ''}/>
                    <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.soVuGiaoCoQuanDieuTra)}/>
                    <Text className="col-25 mb0-18" label="Số đối tượng:" value={String(this.props.soDoiTuongGiaoCoQuanDieuTra)}/>
                  </div>
                </div>
              </div>
            </ShowIf>

            <ShowIf condition={this.props.khoiTo}>
              <div className="col-100 no-gutter">
                <div className="col-100 no-gutter pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100 no-gutter mt5">
                  <h2 className="title-12 mb15">Khởi tố</h2>
                  <div className="row pl10 pr10">
                    <div className="col-50 no-gutter">
                      <Text className="col-50 mb0-18" label="Số vụ:" value={String(this.props.soVuBiKhoiTo)}/>
                      <Text className="col-50 mb0-18" label="Số đối tượng:" value={String(this.props.soDoiTuongBiKhoiTo)}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
          </ShowIf>
          <div className="col-100 pb5 no-gutter">
            <ContainerFileDinhKem name="GiaoCQDT" label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
          </div>
          <ShowIf condition={!this.props.boSungThongTin && (this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(this.props.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={this.props.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.lanhDaoView != true && !this.props.boSungThongTin}>
            <div className="box-bottom gqd-wrap col-100">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

KetQuaLapDuThaoDonKhieuNaiCanBo.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon,
  }
}

export default connect(bindStateToProps)(KetQuaLapDuThaoDonKhieuNaiCanBo);


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaLapDuThaoDonKhieuNaiCanBo.jsx